import React from "react"
import classnames from "classnames"

import { container, box, clouds, bus, city, squares, boxColored } from "./hero.module.css"

const Hero = ( { pageConfig, children } ) => {
  const { title, description, variant } = pageConfig

  return (
    <div className={ classnames( container, [ { box, clouds, bus, city, squares, boxColored }[ variant ] ] ) }>
      <header>
        <h1>{ title }</h1>
        <p>{ description }</p>
        { children }
      </header>
    </div>
  )
}

export default Hero
